/*
 *
 * OrderPatientSearch actions
 *
 */

import {
  DEFAULT_ACTION,
  GET_PATIENTS,
  GET_PATIENTS_SUCCESS,
  GET_PATIENTS_ERROR,
} from "./constants";

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function getPatients(filter) {
  return {
    type: GET_PATIENTS,
    filter,
  };
}

export function getPatientsSuccess(patients,total) {
  return {
    type: GET_PATIENTS_SUCCESS,
    patients,
    total
  };
}

export function getPatientsError(error) {
  return {
    type: GET_PATIENTS_ERROR,
    error,
  };
}
